// Terminal Text Reveal Animation (ES Module)
// Uses global gsap, ScrollTrigger, and SplitText from window object

document.addEventListener("DOMContentLoaded", async () => {
     if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
          console.warn('⚠️ Terminal Text Reveal: GSAP or ScrollTrigger not loaded');
          return;
     }
     
     gsap.registerPlugin(ScrollTrigger, SplitText);

     function initTerminalTextReveal() {
          const targetElement = document.getElementById('sdrHeroTitle');

          if (!targetElement) {
               console.log('sdrHeroTitle element not found');
               return;
          }

          const colorInitial = getComputedStyle(document.documentElement).getPropertyValue('--color-text-disabled').trim() || '#dddddd';
          const colorAccent = getComputedStyle(document.documentElement).getPropertyValue('--color-brand-primary').trim() || '#9332a8';
          const colorFinal = getComputedStyle(document.documentElement).getPropertyValue('--color-text-primary').trim() || '#000000';

          let lastScrollProgress = 0;
          const colorTransitionTimers = new Map();
          const completedChars = new Set();
          let allChars = [];
          let wordSplit = null;
          let charSplit = null;

          wordSplit = SplitText.create(targetElement, {
               type: "words",
               wordsClass: "word",
          });

          charSplit = SplitText.create(wordSplit.words, {
               type: "chars",
               charsClass: "char",
          });

          allChars = charSplit.chars;

          gsap.set(allChars, { color: colorInitial });

          const scheduleFinalTransition = (char, index) => {
               if (colorTransitionTimers.has(index)) {
                    clearTimeout(colorTransitionTimers.get(index));
               }

               const timer = setTimeout(() => {
                    if (!completedChars.has(index)) {
                         gsap.to(char, {
                              duration: 0.1,
                              ease: "none",
                              color: colorFinal,
                              onComplete: () => {
                                   completedChars.add(index);
                              },
                         });
                    }
                    colorTransitionTimers.delete(index);
               }, 100);

               colorTransitionTimers.set(index, timer);
          };

          ScrollTrigger.create({
               trigger: targetElement,
               start: "top 30%",
               end: "top 15%",
               scrub: 1,
               onUpdate: (self) => {
                    const progress = self.progress;
                    const totalChars = allChars.length;
                    const isScrollingDown = progress >= lastScrollProgress;
                    const currentCharIndex = Math.floor(progress * totalChars);

                    allChars.forEach((char, index) => {
                         if (!isScrollingDown && index >= currentCharIndex) {
                              if (colorTransitionTimers.has(index)) {
                                   clearTimeout(colorTransitionTimers.get(index));
                                   colorTransitionTimers.delete(index);
                              }
                              completedChars.delete(index);
                              gsap.set(char, { color: colorInitial });
                              return;
                         }

                         if (completedChars.has(index)) {
                              return;
                         }

                         if (index <= currentCharIndex) {
                              gsap.set(char, { color: colorAccent });
                              if (!colorTransitionTimers.has(index)) {
                                   scheduleFinalTransition(char, index);
                              }
                         } else {
                              gsap.set(char, { color: colorInitial });
                         }
                    });

                    lastScrollProgress = progress;
               },
          });

          return () => {
               colorTransitionTimers.forEach((timer) => clearTimeout(timer));
               colorTransitionTimers.clear();
               completedChars.clear();

               if (charSplit) charSplit.revert();
               if (wordSplit) wordSplit.revert();
          };
     }

     async function waitForGSAP() {
          if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && typeof SplitText !== 'undefined') {
               try {
                    if (document.fonts && document.fonts.ready) {
                         await document.fonts.ready;
                    }
               } catch (e) { }
               initTerminalTextReveal();
               console.log('✅ Terminal Text Reveal initialized');
          } else {
               setTimeout(waitForGSAP, 100);
          }
     }

     waitForGSAP();
});

export default {};
